var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.37146 2.4C1.37146 2.18783 1.45575 1.98434 1.60577 1.83431C1.7558 1.68428 1.95929 1.6 2.17146 1.6H4.57146C4.78363 1.6 4.98712 1.68428 5.13715 1.83431C5.28717 1.98434 5.37146 2.18783 5.37146 2.4V5.6C5.37146 5.81217 5.28717 6.01565 5.13715 6.16568C4.98712 6.31571 4.78363 6.4 4.57146 6.4H2.17146C1.95929 6.4 1.7558 6.31571 1.60577 6.16568C1.45575 6.01565 1.37146 5.81217 1.37146 5.6V2.4ZM6.39266 2.8424C6.32623 2.87559 6.27035 2.92663 6.23128 2.98979C6.19221 3.05295 6.1715 3.12573 6.17146 3.2V4.8C6.1715 4.87426 6.19221 4.94705 6.23128 5.01021C6.27035 5.07337 6.32623 5.1244 6.39266 5.1576L7.19266 5.5576C7.25363 5.58806 7.32137 5.60245 7.38946 5.59938C7.45754 5.59631 7.52372 5.5759 7.5817 5.54008C7.63968 5.50425 7.68755 5.45421 7.72076 5.39469C7.75397 5.33517 7.77142 5.26816 7.77146 5.2V2.8C7.77142 2.73184 7.75397 2.66483 7.72076 2.60531C7.68755 2.54579 7.63968 2.49574 7.5817 2.45992C7.52372 2.4241 7.45754 2.40368 7.38946 2.40062C7.32137 2.39755 7.25363 2.41193 7.19266 2.4424L6.39266 2.8424Z",
    fill: "#E0F2FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamera);
export default __webpack_public_path__ + "static/media/video-camera.1b3043d9d61c4d044adb438d98482ce1.svg";
export { ForwardRef as ReactComponent };